import React, { useContext, useRef, useState, useEffect } from 'react'
import {
    DataView, LoadingComponent, LoadingButton,
    ContentModal, ConfirmModal, ToastsContainer, LocalStorage
} from 'usbc-web-react-library'
import GlobalContext from '../../../store/global-context'
import OrderItem from '../OrderItem/OrderItem'
import useDashboardApi from '../../../hooks/useDashboardApi'
import OrderEditForm from './OrderEditForm/OrderEditForm';
import OrderDetailsView from './OrderDetailsView/OrderDetailsView';
import './OrderList.css'
import { useNavigate } from 'react-router-dom'

let requestData = {};

function OrderList() {
    const defaultLayout = LocalStorage.get("LayoutOrderList") || 1;
    const globalCtx = useContext(GlobalContext);
    const newSeasonBeginDate = globalCtx.layoutModel?.newSeasonBeginDate;
    let navigate = useNavigate();

    const [listColumnsCountState, setListColumnsCountState] = useState(Number(defaultLayout));
    const currentListColumnsCount = useRef(Number(defaultLayout));
    const prevListColumnsCount = useRef(null);

    const [showEditOrder, setShowEditOrder] = useState(false);
    const [orderToAction, setOrderToAction] = useState(null);
    const [toasts, setToastsState] = useState([]);

    const [canAddOrder, setCanAddOrder] = useState(true);
    const [hasIncompleteOrder, setHasIncompleteOrder] = useState(false);
    const [incompleteOrder, setIncompleteOrder] = useState(null);
    const [hasOrders, setHasOrders] = useState(null);

    const [showConfirmSubmit, setShowConfirmSubmit] = useState(false);
    const [showConfirmCancel, setShowConfirmCancel] = useState(false);
    const [showConfirmAdd, setShowConfirmAdd] = useState(false);
    const [confirmShipping, setConfirmShipping] = useState(false);
    const [orderLoading, setOrderLoading] = useState(false);

    const {
        hasPermission,
        response: hasPermissionResult,
        loading: permissionLoading,
        setResponse: setPermissionResult
    } = useDashboardApi();

    const {
        getOrders,
        response: ordersResult,
        loading: ordersLoading,
        setResponse: setOrdersResult
    } = useDashboardApi();

    const {
        addOrder,
        response: addOrderResult,
        loading: addOrderLoading,
        setResponse: setAddOrderResult,
    } = useDashboardApi();

    const {
        submitOrder,
        response: submitOrderResult,
        loading: submitOrderLoading
    } = useDashboardApi();

    const {
        cancelOrder,
        response: cancelOrderResult,
        loading: cancelOrderLoading
    } = useDashboardApi();

    useEffect(() => {
        if (hasPermissionResult) {
            requestData = {};
            getOrders().then(data => {
                globalCtx.setHasCurrentSeasonSubmittedOrder(data.hasCurrentSeasonSubmittedOrder);
                if (!data?.orders || data.orders.length == 0 || !data.hasCurrentSeasonOrder) { setShowConfirmAdd(true); setHasOrders(false) }
                else
                    data?.orders.forEach(checkForIncomplete);

            });

            // Set up the event listener on mount
            window.addEventListener('resize', handleResize);

            // Remove the event listener on unmount
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }

    }, [hasPermissionResult]);
    useEffect(() => {
        hasPermission(["CanAddAdditionOrder"]);
    }, []);

    const handleResize = () => {
        if (window.innerWidth <= 992) {
            if (currentListColumnsCount.current !== 1) {
                prevListColumnsCount.current = currentListColumnsCount.current;
                currentListColumnsCount.current = 1;
                setListColumnsCountState(1);
            }
        } else if (!!prevListColumnsCount?.current) {
            currentListColumnsCount.current = prevListColumnsCount.current;
            setListColumnsCountState(prevListColumnsCount.current);
        }
    };

    const seasonDate = getBeginDate();

    function getBeginDate() {
        let n = newSeasonBeginDate;
        let y = n.split(', ');
        let year = Number(y[1]);
        let z = y[0].split(' ');
        let m = z[0];
        let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let day = Number(z[1]);
        let month = months.indexOf(m);
        return new Date(year, month, day);
    }

    function convertOrderDate(date) {
        if (date > '') {
            let d = date.split('/');
            return new Date(Number(d[2]), Number(d[0]) - 1, Number(d[1]));
        } else {
            return new Date(1900, 1, 1);
        }
    }

    function checkForIncomplete(order) {
        if (!hasIncompleteOrder && order.status === 'Incomplete') {
            setHasIncompleteOrder(true);
            setIncompleteOrder(order);
        } else if (canAddOrder) {
            let orderDate = convertOrderDate(order.orderDate);
            if (orderDate > seasonDate && (!hasPermissionResult["CanAddAdditionOrder"] || order.status == "Incomplete")) {
                setCanAddOrder(false);
            }
        }
    }

    /* Perform the action **************************************************/

    function onAddOrder() {
        addOrder().then(data => {
            onOrderAdded();
        });
    }

    function onSubmitOrder() {
        submitOrder().then(data => {
            onOrderSubmitted();
        });
    }

    function onCancelOrder() {
        cancelOrder().then(data => {
            onOrderCanceled();

        });
    }

    /* Complete the action *************************************************/

    function onOrderAdded() {
        getOrders().then(data => {
            globalCtx.setHasCurrentSeasonSubmittedOrder(data.hasCurrentSeasonSubmittedOrder);
            let incomplete = {};
            data?.orders.forEach(x => {
                checkForIncomplete(x);
                if (x.status === 'Incomplete')
                    incomplete = x;
            });
            if (incomplete && incomplete.status && incomplete.name) {
                navigate(`/SupplyList/${incomplete?.id}/${incomplete?.name}/${incomplete?.status}`);
                pushToToasts(`Order added`, 'success');
            }
            else
                pushToToasts(`Order not added`, 'error');

        });
    }

    function onOrderSaved() {
        getOrders();
        setShowEditOrder(false);
        pushToToasts(`Order saved`, 'success');
    }

    function onOrderSubmitted() {
        setOrderLoading(true);
        setOrderLoading(false);
        getOrders().then(data => {
            setHasIncompleteOrder(false);
            data?.orders.forEach(checkForIncomplete);
            pushToToasts(`Order submitted`, 'success');
        });

    }

    function onOrderCanceled() {
        getOrders().then(data => {
            setHasIncompleteOrder(false);
            data?.orders.forEach(checkForIncomplete);
            pushToToasts(`Order canceled`, 'success');
        });
    }

    /* Action has been initiated by user **********************************/

    function onEditOrderHandler(order) {
        setOrderToAction(order);
        setShowEditOrder(true);
        setConfirmShipping(false);
    }

    // Returning from OrderEditForm when verifying shipping while submitting order.
    // Shipping has already been saved.
    function onShippingConfirmed() {
        setShowEditOrder(false);
        setConfirmShipping(false);
        onSubmitOrder();
    }

    function onSubmitConfirmHandler() {
        setOrderToAction(incompleteOrder);
        setConfirmShipping(true);
        setShowEditOrder(true);
        setShowConfirmSubmit(false);
    }

    function onCancelConfirmHandler(order) {
        setShowConfirmCancel(false);
        onCancelOrder();
    }
    function onAddConfirmHandler(order) {
        setShowConfirmAdd(false);
        onAddOrder();
    }
    function layoutChangedHandler(layout) {
        prevListColumnsCount.current = layout;
        currentListColumnsCount.current = layout;
        setListColumnsCountState(layout);
        LocalStorage.set("LayoutOrderList", layout);
    }

    function onPageChangedHandler(pageIndex, pageSize) {
        requestData = {
            ...requestData,
            pagingInfo: {
                pageSize: pageSize,
                currentPage: pageIndex
            }
        };
        getOrders();
    }

    /* Presentation **********************************************/

    function notifications() {
        if (hasIncompleteOrder) {
            return <div className="alert alert-warning d-flex align-items-center px-2 py-1" role="alert">
                <i className="bi bi-exclamation-triangle me-2 notifications-icon" ></i>
                <div>
                    <b>Please note:</b> If any quantities on the incomplete order need to be different,
                    please <span className="emphasized">STOP</span> and email{' '}
                    <a href="mailto:supplyorders@bowl.com" target="_blank>supplyorders@bowl.com">supplyorders@bowl.com</a>,{' '}
                    <span className="emphasized">DO NOT</span> submit the order.
                </div>
            </div>
        } else if (!canAddOrder) {
            return <div className="alert alert-info d-flex align-items-center px-2 py-1" role="alert">
                <i className="bi bi-info-square me-2 notifications-icon" ></i>
                <div>
                    An order has been submitted for the current season.  If you want any changes for that order, please email{' '}
                    <a href="mailto:supplyorders@bowl.com" target="_blank>supplyorders@bowl.com">supplyorders@bowl.com</a>.
                </div>
            </div>
        }
    }

    function controlButtons() {
        if (hasIncompleteOrder) {
            return <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <div className={ordersResult.hasCurrentSeasonSubmittedOrder ? 'tooltip-container' : ""}>
                    <LoadingButton type="button"
                        className="btn btn-success bg-usbc-green me-md-1"
                        loadingText='Submitting Order'
                        disabled={ordersResult.hasCurrentSeasonSubmittedOrder}
                        loading={submitOrderLoading || orderLoading}
                        onClick={() => setShowConfirmSubmit(true)}>
                        <i className="bi bi-save" />
                        <span className="ms-2">Submit Order</span>
                        {ordersResult.hasCurrentSeasonSubmittedOrder &&
                            <div>
                                <span className="tooltip-text">Please wait for the existing Submitted order to be Completed</span>
                            </div>}

                    </LoadingButton>
                </div>

                <LoadingButton type="button"
                    className="btn btn-primary"
                    loadingText='Cancelling Order'
                    loading={cancelOrderLoading}
                    onClick={() => setShowConfirmCancel(true)}>
                    <i className="bi bi-x-circle" />
                    <span className="ms-2">Cancel Order</span>
                </LoadingButton>
            </div>
        } else if (canAddOrder) {
            return <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <LoadingButton type="button"
                    className="btn btn-primary"
                    loadingText='Creating Order'
                    loading={addOrderLoading}
                    onClick={() => onAddOrder()}>
                    <i className="bi bi-plus-square" />
                    <span className="ms-2">Add Order</span>
                </LoadingButton>
            </div>
        }
    }

    function orderItemTemplate(order, index, layout) {
        return <
            OrderItem order={order} index={index} layout={layout} hasCurrentSeasonSubmittedOrder={ordersResult.hasCurrentSeasonSubmittedOrder}
            onEditOrder={() => onEditOrderHandler(order)}
            onSubmitOrder={() => setShowConfirmSubmit(true)}
            onCancelOrder={() => setShowConfirmCancel(true)}
        />;
    }

    function headerTemplate(layout) {
        return <tr>
            <th scope="col">Order Status</th>
            <th scope="col">Order Date</th>
            <th scope="col">Ship Date</th>
            <th scope="col">Placed By</th>
            <th scope="col"># Items</th>
            <th scope="col"></th>
        </tr>;
    }

    function pushToToasts(message, type) {
        setToastsState((prev) => { return [...prev, { type: type, text: message }] });
    }

    return (
        <>
            <LoadingComponent isLoading={() => ordersLoading === true || permissionLoading} description='Loading orders'>
                <DataView
                    data={ordersResult?.orders}
                    itemTemplate={orderItemTemplate}
                    headerTemplate={headerTemplate}
                    defaultLayout={listColumnsCountState}
                    onColumnsCountChanged={(layout) => layoutChangedHandler(layout)}
                    emptyText="No orders found"
                    controlButtons={controlButtons}
                    middleArea={notifications} />
            </LoadingComponent>
            {
                (showEditOrder === true && !!orderToAction && orderToAction.status === 'Incomplete' && !confirmShipping) &&
                <ContentModal show={showEditOrder}
                    icon={<i className="bi bi-clipboard me-2 content-modal-icon"></i>}
                    title='Edit Order' modelHide={() => setShowEditOrder(false)}
                    showClose={true} size="modal-lg">
                    <OrderEditForm onOrderSaved={onOrderSaved} onCancel={() => setShowEditOrder(false)} order={orderToAction} />
                </ContentModal>
            }
            {
                (showEditOrder === true && !!orderToAction && orderToAction.status === 'Incomplete' && confirmShipping) &&
                <ContentModal show={showEditOrder}
                    icon={<i className="bi bi-clipboard me-2 content-modal-icon"></i>}
                    title='Confirm Shipping' modelHide={() => setShowEditOrder(false)}
                    showClose={true} size="modal-lg">
                    <OrderEditForm onOrderSaved={onShippingConfirmed} onCancel={() => setShowEditOrder(false)} order={orderToAction} />
                </ContentModal>
            }
            {
                (showEditOrder === true && !!orderToAction && (orderToAction.status === 'Submitted' || orderToAction.status === 'Completed')) &&
                <ContentModal show={showEditOrder}
                    icon={<i className="bi bi-clipboard me-2 content-modal-icon"></i>}
                    title='View Order' modelHide={() => setShowEditOrder(false)}
                    showClose={true} size="modal-lg">
                    <OrderDetailsView onCancel={() => setShowEditOrder(false)} order={orderToAction} />
                </ContentModal>
            }
            {
                (hasIncompleteOrder && showConfirmSubmit === true) &&
                <ConfirmModal
                    show={showConfirmSubmit}
                    modelHide={() => setShowConfirmSubmit(false)}
                    question="Do you want to submit the order?"
                    yesHandler={() => onSubmitConfirmHandler()}
                    noHandler={() => setShowConfirmSubmit(false)}>
                </ConfirmModal>
            }
            {
                (hasIncompleteOrder && showConfirmCancel === true) &&
                <ConfirmModal
                    show={showConfirmCancel}
                    modelHide={() => setShowConfirmCancel(false)}
                    question="Do you want to cancel the order?"
                    yesHandler={() => onCancelConfirmHandler()}
                    noHandler={() => setShowConfirmCancel(false)}>
                </ConfirmModal>
            }
            {
                (!hasOrders && showConfirmAdd === true) &&
                <ConfirmModal
                    show={showConfirmAdd}
                    modelHide={() => setShowConfirmAdd(false)}
                    question="You have not created a Supply Order for the current season, would you like to create one?"
                    yesHandler={() => onAddConfirmHandler()}
                    noHandler={() => setShowConfirmAdd(false)}>
                </ConfirmModal>
            }
            <ToastsContainer toasts={toasts} />
        </>
    );
}

export default OrderList